import { Loader } from "@itandi/itandi-bb-ui";
import type { NextPage } from "next";
import { createContext, useContext, useMemo } from "react";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/new/Page";
import { useDealInfoFromRouter } from "~/hooks/useDealInfoFromRouter";
import useItandiAccount from "~/hooks/useItandiAccount";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import type { DealInfo as KtDealInfo } from "~/utils/NyukyoshaKanriUrlUtil";

interface DealQueryParamsContextValue {
	dealType: KtDealInfo["dealType"];
	leasingId: KtDealInfo["leasingId"];
}

const DealQueryParamsContext = createContext<DealQueryParamsContextValue>({
	dealType: null,
	leasingId: null
});

export const useDealQueryParams = (): DealQueryParamsContextValue =>
	useContext(DealQueryParamsContext);

export const PATH = "/deals/new";

const New: NextPage = () => {
	const { data: account } = useItandiAccount().currentAccount();
	const { leasingId, dealType, isReady } = useDealInfoFromRouter();
	const value = useMemo(() => ({ dealType, leasingId }), [leasingId, dealType]);
	if (!isReady || account === null) return <Loader />;

	return (
		<>
			<NskHead title="案件追加" />
			<ItandiAccountContext.Provider value={account}>
				<DealQueryParamsContext.Provider value={value}>
					<Component />
				</DealQueryParamsContext.Provider>
			</ItandiAccountContext.Provider>
		</>
	);
};

export default New;
